import React from 'react';
import { useSelector } from 'react-redux';
import { getFlags } from '../redux/selectors';
import { FlagContext } from '../FlagContext';
const ConnectedFlagsProvider = ({ children })=>{
    const flags = useSelector(getFlags);
    return /*#__PURE__*/ React.createElement(FlagContext.Provider, {
        value: flags
    }, children);
};
ConnectedFlagsProvider.displayName = 'ConnectedFlagsProvider';
export default ConnectedFlagsProvider;
